enum ThemeFontStyleTypeEnum {
	bodySmall = 'bodySmall',
	bodyMedium = 'bodyMedium',
	bodyLarge = 'bodyLarge',
	bodyXLarge = 'bodyXLarge',
	headingXSmall = 'headingXSmall',
	headingSmall = 'headingSmall',
	headingMedium = 'headingMedium',
	headingLarge = 'headingLarge',
	headingXLarge = 'headingXLarge',
	priceXSmall = 'priceXSmall',
	priceSmall = 'priceSmall',
	priceMedium = 'priceMedium',
	priceLarge = 'priceLarge',
	priceXLarge = 'priceXLarge',
	priceXXLarge = 'priceXXLarge'
}

export default ThemeFontStyleTypeEnum;
